import { NavLink, useParams } from "react-router";
import t from "@/lang/lang";
import { H3 } from "@/shared/components/typography";
import {
  CustomerPageMain,
  CustomerPageMainContent,
  CustomerPageMainHeader,
} from "@/routes/customers/[customerId]/_components/customer-page";
import { CustomerPageBreadcrumbs } from "@/routes/customers/[customerId]/_components/customer-page-breadcrumbs";
import { useBuildingsByAddressListQuery } from "@/services/backend/buildings/api/building-by-address-api";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/shared/components/ui/table";
import { TableCard } from "@/shared/components/tables/table-card";
import { TableEmptyRow } from "@/shared/components/tables/table-empty-row";
import { TableLoadingRow } from "@/shared/components/tables/table-loading-row";
import { TableRtkErrorRow } from "@/shared/components/tables/table-rtk-error-row";
import { Button } from "@/shared/components/ui/button";
import { addressListLabel } from "@/services/backend/addresses/types/address";

export function BuildingAddressesRoute() {
  const { customerId } = useParams();
  const { data, isLoading, error } = useBuildingsByAddressListQuery(
    { customer: { active: true, values: [customerId!] } },
    {
      skip: !customerId,
      refetchOnMountOrArgChange: true,
    },
  );

  return (
    <CustomerPageMain>
      <CustomerPageMainHeader>
        <CustomerPageBreadcrumbs
          breadcrumbs={[
            {
              to: `/customers/${customerId}/buildings`,
              label: t("Gebäudeverwaltung"),
            },
            {
              to: `/customers/${customerId}/buildings/addresses`,
              label: t("Adressen"),
            },
          ]}
        />
      </CustomerPageMainHeader>
      <CustomerPageMainContent>
        <div className="grid gap-1">
          <H3>{t("Adressen")}</H3>
          <div className="text-muted-foreground text-sm">
            {t(
              "Hier werden alle verwendeten Gebäudeadressen eines Kunden angezeigt.",
            )}
          </div>
        </div>
        <TableCard>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>{t("Adresse")}</TableHead>
                <TableHead>{t("Gebäude")}</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {isLoading && <TableLoadingRow colSpan={2} />}
              {error && <TableRtkErrorRow error={error} colSpan={2} />}
              {data && data.items.length === 0 && <TableEmptyRow colSpan={2} />}
              {data &&
                data.items.map((group) => (
                  <TableRow key={group.addressKey}>
                    <TableCell className="py-0">
                      <Button
                        variant="link"
                        className="h-auto px-0 py-0"
                        asChild
                      >
                        <NavLink
                          to={`/customers/${customerId}/buildings/addresses/${group.addressKey}`}
                        >
                          {addressListLabel(group.address)}
                        </NavLink>
                      </Button>
                    </TableCell>
                    <TableCell>{group.buildings.length}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableCard>
      </CustomerPageMainContent>
    </CustomerPageMain>
  );
}
